import { createContext } from "react";

 const defaultValue = {
    locale: 'ru',
    setLocale: () => {}
 }

 export default createContext(defaultValue);